import { DefaultValidator } from '../'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const validEmailTranslateKey = 'validator.validEmail'

export const validEmail = (value: string) => {
  if (!value) {
    return true
  }

  const emailRegExp = /^(?=[A-Z])[A-Z0-9_\-\.]+@(?=(([A-Z0-9_\-]+\.)+))\1[A-Z]{2,4}$/i
  return emailRegExp.test(value)
}

export const validEmailTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(validEmail, localeKey || validEmailTranslateKey),
)
